<template>
  <!-- Change Request Form -->
  <v-form
    ref="form"
    lazy-validation
    v-bind="bind_subscription_form"
     >

    <v-dialog
      v-model="subscriptionDialog"
      content-class="documentDialog subscriptionDialog"
      transition="scale-transition"
      persistent
      scrollable
      @keydown.esc="closePopup()">
      <v-btn v-if="subscriptionType === 'getOffer'" slot="activator" class="primary white--text title subheading">
        Send me a quote
      </v-btn>
      <v-btn v-if="!authenticated && subscriptionType === 'getDemoAccess' && subscriptionFormCompPosition !== 'tooltipBar'"
        slot="activator" class="primary" flat>
        Register
      </v-btn>
      <v-btn v-if="subscriptionType === 'newUser'" slot="activator" class="primary white--text subheading">
        Create new user
      </v-btn>

      <v-btn v-if="subscriptionType === 'getDemoAccess' && subscriptionFormCompPosition === 'tooltipBar'" slot="activator"
      class="white--text py-1" style="background-color: #f6a200; margin-left:8px;margin-right:8px;height: auto;">
        Register
      </v-btn>

      <v-btn v-if="subscriptionType === 'register'" slot="activator" >
        Register
      </v-btn>

      <v-card xs12>
        <v-card-title class="documentDialog_title primary">
          <v-layout row wrap >
            <v-flex xs11>
              <p v-if="subscriptionType === 'register'">Sign up</p>
              <p v-if="subscriptionType === 'getDemoAccess'">Sign up</p>
              <p v-if="subscriptionType === 'newUser'">Create New user</p>
              <p v-if="subscriptionType === 'getOffer'">Billing information for the quote</p>
            </v-flex>
            <v-flex xs1 style="text-align: right;">
              <v-btn dark icon
                @click="closePopup()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text style="padding: 0px!important;">
          <v-stepper v-model="step">
              <v-stepper-header style="visibility:hidden; height:0px;">
                <v-stepper-step :complete="step > 1" step="1">Complete the inscription form</v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="step > 2" step="2">Send</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items>
                <v-stepper-content step="1">

                  <v-alert v-if="show_error_message" :value="show_error_message" type="error" >{{ show_error_message }}</v-alert>
                  <br v-if="show_error_message" />

                  <div v-if="subscriptionType !== 'getOffer'">
                    <v-text-field v-model="subscription.firstname" :counter="60" label="Firstname" name="firstname"
                    :rules="[rules.required]" />
                    <v-text-field v-model="subscription.lastname" :counter="60" label="Lastname" name="lastname"
                    :rules="[rules.required]" />
                    <v-text-field v-model="subscription.email" :counter="60" label="Email"  name="email"
                      :rules="[rules.required, rules.email]"
                      data-vv-name="email"
                      :error-messages="errors.collect('email')"
                      v-validate="'required'"
                      required />
                    <v-text-field v-model="subscription.password" :counter="60" label="Password" name="password"
                    :type="show_password ? 'text' : 'password'"
                    :append-icon="show_password ? 'visibility' : 'visibility_off'"
                    :rules="[rules.required, rules.min]"
                    hint="At least 4 characters"
                    @click:append="show_password = !show_password"
                    data-vv-name="password"
                    :error-messages="errors.collect('password')"
                    v-validate="'required'"
                    required />
                    <v-text-field v-model="subscription.company_name" :counter="120" label="Company name" name="company"
                      :rules="[rules.required]"
                      data-vv-name="company_name"
                      :error-messages="errors.collect('company_name')"
                      v-validate="'required'" />
                    <v-checkbox v-model="subscription.tfwa_member" label="My company is a TFWA member"></v-checkbox>
                  </div>
                  <div v-if="subscriptionType === 'getOffer'">
                    <v-text-field v-model="subscription.billing_firstname" :counter="60" label="Firstname" name="firstname"
                    :rules="[rules.required]" />
                    <v-text-field v-model="subscription.billing_lastname" :counter="60" label="Lastname" name="lastname"
                    :rules="[rules.required]" />
                    <v-text-field v-model="subscription.billing_company_name" :counter="60" label="Company name" name="company"
                    :rules="[rules.required]" />
                    <v-text-field v-model="subscription.billing_phone" :counter="60" label="Phone" name="phone" />
                    <v-text-field v-model="subscription.billing_vat" :counter="60" label="VAT" name="vat" />
                  </div>
              </v-stepper-content>
              <v-stepper-content step="2">
                <div class="mb-5" height="200px" style="text-align:center; padding-top:50px;">
                  <h3 v-if="subscriptionType === 'newUser'">
                    Done!
                  </h3>
                  <h3 v-if="subscriptionType === 'getDemoAccess'">
                    Congratulations!<br/>
                    Your account is now ready to use.<br/>
                    <v-btn class="primary white--text" @click.native="$auth0.login();closePopup();">Login</v-btn>
                  </h3>
                  <h3 v-if="subscriptionType === 'getOffer'">
                    Thanks for your interest!<br/>
                    We will get back to you soon!
                  </h3>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-card-actions class="bottom_panel">
          <!-- new subscription from admin panel -->
          <v-btn color="primary" @click="validate()" v-if="step == 1 && subscriptionType === 'newUser'">Create New user</v-btn>
          <!-- sign up -->
          <v-btn class="primary white--text" @click="validate()" v-if="step == 1 && subscriptionType === 'getDemoAccess'">Register</v-btn>
          <!-- send me an offer -->
          <v-btn class="primary white--text" @click="validate()" v-if="step == 1 && subscriptionType === 'getOffer'">Send me a quote</v-btn>
          <v-btn flat @click.native="closePopup()" v-if="step == 1" >Cancel</v-btn>

          <v-btn flat @click.native="closePopup()" v-if="step == 2">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import NEW_SUBSCRIPTION from '@/graphql/NewSubscription.gql'

export default {
  name: 'SubscriptionForm',
  props: {
    articlesUserQuantity: {
      type: Number,
      default: 0
    },
    companyReportsUserQuantity: {
      type: Number,
      default: 0
    },
    localizationsUserQuantity: {
      type: Number,
      default: 0
    },
    searchEngineUserQuantity: {
      type: Number,
      default: 0
    },
    wikiUserQuantity: {
      type: Number,
      default: 0
    },
    subscriptionType: {
      type: String
    },
    subscriptionFormCompPosition: {
      type: String
    }
  },
  data () {
    return {
      subscriptionDialog: false,
      active: -1,
      displayNewSubscription: true,
      subscription: {
        'type': '',
        'user_sub': '',

        'lastname': '',
        'firstname': '',
        'email': '',
        'password': '',
        'company_name': '',
        'tfwa_member': false,
        'phone': '',
        'country': '',

        'billing_firstname': '',
        'billing_lastname': '',
        'billing_company_name': '',
        'billing_phone': '',
        'billing_vat': ''
      },
      error_message: null,
      step: 1,
      dictionary: {
        custom: {
          email: {
            required: () => 'Email can not be empty'
          },
          password: {
            required: () => 'Password can not be empty'
          },
          company_name: {
            required: () => 'Company name can not be empty'
          }
        }
      },
      show_password: false,
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 4 || 'Min 4 characters',
        // emailMatch: () => ('The email and password you entered don\'t match')
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      show_error_message: null,
    }
  },
  mounted () {
    this.$validator.localize('en', this.dictionary)
  },
  computed: {
    ...mapState(['authenticated', 'userProfile']),
    bind_subscription_form () {
      const binding = {}
      binding.style = ''
      if (this.subscriptionFormCompPosition === 'tooltipBar') {
        binding.style = 'padding-top:17px;'
      }
      return binding
    }
  },
  methods: {
    ...mapMutations(['addError']),
    async validate () {
      if (!this.$refs.form.validate()) {
        return
      }
      let check = await this.$validator.validateAll()
      if (!check) { return }

      this.subscription.type = this.subscriptionType
      if (this.subscriptionType === 'getOffer' && this.authenticated) {
        // user ask for a new offer
        this.subscription.user_sub = this.userProfile.sub
      }
      this.subscription.articles_user_quantity = parseInt(this.articlesUserQuantity)
      this.subscription.company_reports_user_quantity = parseInt(this.companyReportsUserQuantity)
      this.subscription.localizations_user_quantity = parseInt(this.localizationsUserQuantity)

      this.subscription.searchEngineUserQuantity = parseInt(this.searchEngineUserQuantity)
      this.subscription.wikiUserQuantity = parseInt(this.wikiUserQuantity)

      this.$apollo.mutate({
        mutation: NEW_SUBSCRIPTION,
        variables: {
          new_subscription: this.subscription
        }
      }).then((data) => {
        // TODO: refactore to use something similar than the errors_info state
        if (!(data !== undefined && data.data !== undefined && data.data.newSubscription.statusCode === undefined)) {
          this.show_error_message = `An error appeared when trying to send your request: \n${data.data.newSubscription.message}`
          return
        }
        this.step = 2
      })
    },
    onPopupClose (event) {
      if (event === undefined) {
        this.closePopup()
      }
    },
    closePopup () {
      this.subscriptionDialog = false
      this.step = 1
      this.show_error_message = null
      this.subscription = {
        'type': '',
        'user_sub': '',

        'lastname': '',
        'firstname': '',
        'email': '',
        'password': '',
        'company_name': '',
        'phone': '',
        'country': '',

        'billing_firstname': '',
        'billing_lastname': '',
        'billing_company_name': '',
        'billing_phone': '',
        'billing_vat': ''
      }
    }
  }
}
</script>
<style>

</style>
